import { render, staticRenderFns } from "./Modalidade.vue?vue&type=template&id=119d5ebe"
import script from "./Modalidade.vue?vue&type=script&lang=js"
export * from "./Modalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports